import { formatDateToRssFeed } from '@mais-retorno-front/helpers/date';
import { formatContentToFeeds } from '@mais-retorno-front/helpers/format';
import { IFeeds } from '@mais-retorno-front/models/feed.model';
import { AxiosInstance } from 'axios';

interface IResponse {
  data: {
    noticias: {
      data: {
        attributes: {
          path: string;
          slug: string;
          title: string;
          publishedAt: string;
          updatedAt: string;
          content: string;
          author: {
            data: {
              attributes: {
                name: string;
              };
            };
          };
          thumbnail: {
            data: {
              attributes: {
                url: string;
              };
            };
          };
          categories: {
            data: {
              attributes: {
                title: string;
              };
            }[];
          };
        };
      }[];
    };
  };
}

export class GetTagsFeedUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(tagSlug: string, date: string): Promise<IFeeds[]> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query newsByCategory {
          noticias(
            filters: { publishedAt: { gt: "${date}" }, tags: { slug: { eq: "${tagSlug}" } } }
            sort: "publishedAt:desc"
            pagination: { pageSize: 500 }
          ) {
            data {
              attributes {
                path
                slug
                title
                publishedAt
                updatedAt
                content
                author {
                  data {
                    attributes {
                      name
                    }
                  }
                }
                thumbnail {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                categories {
                  data {
                    attributes {
                      title
                    }
                  }
                }
              }
            }
          }
        }
      `,
    });

    const newsContent = data?.data?.noticias?.data;

    if (!newsContent || newsContent.length === 0) {
      return null;
    }

    return newsContent.map((news) => {
      const keywords = news?.attributes?.categories?.data
        ?.map((keyword) => keyword?.attributes?.title)
        .join(', ');

      return {
        title: news?.attributes?.title,
        publishedAt: formatDateToRssFeed(news?.attributes?.publishedAt),
        content: formatContentToFeeds(news?.attributes?.content),
        updatedAt: formatDateToRssFeed(news?.attributes?.updatedAt),
        url: `${process.env.NEXT_PUBLIC_DOMAIN}${news?.attributes.path}/${news?.attributes.slug}`,
        author: news?.attributes?.author?.data?.attributes?.name,
        contentCategories: [keywords || 'notícias'],
        thumbnail: {
          url: news.attributes?.thumbnail?.data?.attributes?.url || null,
        },
      };
    });
  }
}
